import { render, staticRenderFns } from "./fund-cluster.vue?vue&type=template&id=18c87b92&"
import script from "./fund-cluster.vue?vue&type=script&lang=js&"
export * from "./fund-cluster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports